import React from 'react';
import styled from "styled-components";

const SGrammarSerestarhaber = styled.div`
  flex: 1;
  padding: 5px 20px;
`;

const GrammarSerestarhaber = () => {
  return (
  <SGrammarSerestarhaber>
<h5>Ser/Estar/Haber - czasowniki wyrażające polski czasownik 'być'</h5>

<h6>użycie czasownika <b>ser</b></h6>
<b>1.</b> przy określaniu czasu<br/>
&nbsp;&nbsp;&nbsp;&nbsp;<i>Es la una</i> - Jest pierwsza.<br/>
<b>2.</b> przy wyrażaniu przynależności<br/>
&nbsp;&nbsp;&nbsp;&nbsp;<i>Este bolso es de Carmen</i> - Ta torebka jest Carmen.<br/>
<b>3.</b> przy wyrażaniu stałych cech osób lub przedmiotów<br/>
&nbsp;&nbsp;&nbsp;&nbsp;<i>Mi casa es muy bonita</i> - Mój dom jest bardzo ładny.<br/>
&nbsp;&nbsp;&nbsp;&nbsp;<i>Es un chico joven</i> - Jest młodym chłopakiem.<br/>
<b>4.</b> w znaczeniu odbywać się<br/>
&nbsp;&nbsp;&nbsp;&nbsp;<i>La conferencia es manana</i> - Konferencja jest jutro.<br/>
<b>5.</b> przy określaniu pochodzenia, wyznania, ideologii, etc.<br/>
&nbsp;&nbsp;&nbsp;&nbsp;<i>Somos polacos</i> - Jesteśmy Polakami.<br/>
&nbsp;&nbsp;&nbsp;&nbsp;<i>Mis padres no son católicos</i> - Moi rodzice nie są katolikami.<br/>
<b>6.</b> oraz w wielu utartych określeniach<br/>
&nbsp;&nbsp;&nbsp;&nbsp;<i>ser famoso</i> - być słynnym<br/>
&nbsp;&nbsp;&nbsp;&nbsp;<i>ser rico</i> - być bogatym

<h6>użycie czasownika <b>estar</b></h6>
<b>1.</b> przy określaniu położenia<br/>
&nbsp;&nbsp;&nbsp;&nbsp;<i>Miguel no está en casa</i> - Miguela nie ma w domu.<br/>
<b>2.</b> przy wyrażaniu stanu przejściowego<br/>
&nbsp;&nbsp;&nbsp;&nbsp;<i>El director está ocupado</i> - Dyrektor jest zajęty.<br/>
&nbsp;&nbsp;&nbsp;&nbsp;<i>El cielo está gris</i> - Niebo jest szare.<br/>
<b>3.</b> oraz w wielu zwrotach<br/>
&nbsp;&nbsp;&nbsp;&nbsp;<i>estar bien</i> - być dobrze<br/>
&nbsp;&nbsp;&nbsp;&nbsp;<i>estar contento</i> - być zadowolonym<br/>
&nbsp;&nbsp;&nbsp;&nbsp;<i>estar harto</i> - mieć dosyć

<h6>użycie czasownika <b>haber</b></h6>
<b>1.</b> przy tworzeniu czasów złożonych (nie ma wtedy samodzielnego znaczenia)<br/>
<b>2.</b> używamy jego bezosobowej formy <b>hay</b>, jeśli podmiot jest niekonkretny i jeśli występuje po orzeczeniu<br/>
&nbsp;&nbsp;&nbsp;&nbsp;<i>En la playa hay mucha gente</i> - Na plaży jest dużo ludzi.<br/>
&nbsp;&nbsp;&nbsp;&nbsp;<i>No hay ninguna mesa libre</i> - Nie ma żadnego wolnego stołu.
  </SGrammarSerestarhaber>
  )
};

export default GrammarSerestarhaber;